import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { Box, Button, IconButton, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ConfirmDialog from "../../../Common/Dialog/ConfirmDialog";

import { addQualification, deleteQualification, updateQualification } from "../../../../actions/rmsActions";

import QualificationForm from "./QualificationFormDialog";
import RenderDate from "../../../Common/Date/RenderDate";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        padding: 12,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 18,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));


function QualificationTable({ items, canUpdate, appraisalId, appCode }) {
    const [openDialog, setOpenDialog] = useState(null);
    const [selected, setSelected] = useState(null);

    const dispatch = useDispatch();

    const handleAdd = (params) => dispatch(addQualification(appCode, params, appraisalId));
    const handleEdit = (id, params) => dispatch(updateQualification(id, params, appCode));
    const handleDelete = (id) => dispatch(deleteQualification(id, appCode));

    return (
        <Box className="card-content">
            <TableContainer>
                <Table sx={{ minWidth: 500 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Qualification</StyledTableCell>
                            <StyledTableCell align="center">Achieved</StyledTableCell>
                            <StyledTableCell align="center">Status</StyledTableCell>
                            <StyledTableCell>&nbsp;</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {items
                            .sort((a, b) => a.id - b.id)
                            .map((row) => (
                                <StyledTableRow key={row.id}>
                                    <StyledTableCell>
                                        {row.title}
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <RenderDate date={row.dateAchieved} />
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        {row.status}
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                        {canUpdate && (
                                            <Stack direction="row" justifyContent="flex-end" spacing={0} >
                                                <IconButton
                                                    aria-label="edit"
                                                    disabled={!row.canUpdate}
                                                    onClick={() => {
                                                        setSelected(row);
                                                        setOpenDialog("edit");
                                                    }}
                                                >
                                                    <EditOutlinedIcon />
                                                </IconButton>
                                                <IconButton
                                                    aria-label="delete"
                                                    disabled={!row.canDelete}
                                                    onClick={() => {
                                                        setSelected(row);
                                                        setOpenDialog("delete");
                                                    }}
                                                >
                                                    <DeleteOutlinedIcon />
                                                </IconButton>
                                            </Stack>
                                        )}
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}

                        <StyledTableRow key="totals">
                            <StyledTableCell
                                sx={{ backgroundColor: "#FFFFFF" }}
                                colSpan={4}
                            ></StyledTableCell>
                        </StyledTableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            {canUpdate && (
                <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={2} >
                    <Button
                        startIcon={<AddIcon />}
                        variant="contained"
                        color="primary"
                        aria-label="add qualification"
                        onClick={() => setOpenDialog("add")}
                    >
                        Add
                    </Button>
                </Stack>
            )}

            {(openDialog === "add" || (openDialog === "edit" && !!selected)) && (
                <QualificationForm
                    open
                    formTitle={`${openDialog === "add" ? "Add" : "Edit"} qualification`}
                    data={openDialog === "edit" && selected}
                    onSave={openDialog === "add" ? handleAdd : (params) => handleEdit(selected.id, params)}
                    onClose={() => {
                        setOpenDialog(null);
                        setSelected(null);
                    }}
                    submitLabel={`${openDialog === "add" ? "Add" : "Save"}`}
                />
            )}

            {openDialog === "delete" && !!selected && (
                <ConfirmDialog
                    open
                    title="Delete qualification"
                    content={`The following qualification will be deleted: ${selected.title}`}
                    confirmButtonLabel="Delete"
                    onConfirm={() => handleDelete(selected.id)}
                    onCancel={() => {
                        setOpenDialog(null);
                        setSelected(null);
                    }}
                    onClose={() => {
                        setOpenDialog(null);
                        setSelected(null);
                    }}
                />
            )}
        </Box>
    );
}

export default QualificationTable;
